/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { styled } from '@mui/material';

const Page = styled('div', {
  name: 'Page',
  slot: 'Root',
})({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  minHeight: '100vh',
});

export default Page;
